module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div translate>parcel.yourParcelWasRegistered</div> </h1> <div class=\"box box-border box-border-primary\"> <div class=box-body> <h5 translate>parcel.printAndHandToDriver</h5> </div> </div> </div> </div> <parcel-detail-content parcel=vm.parcel confirmation=true></parcel-detail-content>";


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/parcel-add-confirmation.html
// module id = 555
// module chunks = 0